import { render, staticRenderFns } from "./DefectListPopup.vue?vue&type=template&id=6043d6d8&scoped=true&"
import script from "./DefectListPopup.vue?vue&type=script&lang=js&"
export * from "./DefectListPopup.vue?vue&type=script&lang=js&"
import style0 from "./DefectListPopup.vue?vue&type=style&index=0&id=6043d6d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043d6d8",
  null
  
)

export default component.exports